import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    connected: false,
    selectedPrinter: null,
    settings: {
      cutting: true,
      cuttingPattern: "\x1D\x56\x41\x03",
      paperSize: "80mm",
      margins: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
  },
  getters: {
    isConnected(state) {
      return state.connected;
    },
    selectedPrinter(state) {
      return state.selectedPrinter;
    },
    settings(state) {
      return state.settings;
    },
  },
  mutations: {
    setConnected(state, status) {
      state.connected = status;
    },
    setSelectedPrinter(state, printer) {
      state.selectedPrinter = printer;
    },
    setSettings(state, settings) {
      state.settings = settings;
    },
  },
  actions: {
    setConnectionStatus({ commit }, status) {
      commit("setConnected", status);
    },
    selectPrinter({ commit }, printer) {
      commit("setSelectedPrinter", printer);
    },
    updateSettingsKey({ commit, state }, values) {
      const settings = { ...state.settings };
      if (Array.isArray(values)) settings[values[0]] = values[1];
      else settings[values.key] = values.value;

      commit("setSettings", settings);
    },
  },
};
